module.exports = __webpack_public_path__ + "img/INTELLIGENCE.dc78618d.png";